import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

const FirebaseSourceForm = ({ name, config, errors, onChange, isEdit }) => {
    const handleChange = (field, value) => {
        if (field === 'name') {
            onChange({ name: value, config });
            return;
        }
        let val = value;
        if (field === 'credentials_json' && typeof value === 'string') {
            try {
                val = value.trim() ? JSON.parse(value) : null;
            } catch {
                val = value;
            }
        }
        const next = { ...config, [field]: val };
        onChange({ name, config: next });
    };

    const credentialsStr =
        config?.credentials_json == null
            ? ''
            : typeof config.credentials_json === 'string'
            ? config.credentials_json
            : JSON.stringify(config.credentials_json, null, 2);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
                fullWidth
                label="Tên hiển thị"
                required
                value={name}
                onChange={(e) => handleChange('name', e.target.value)}
                error={!!errors?.name}
                helperText={errors?.name}
            />
            <TextField
                fullWidth
                label="Database URL (Realtime Database)"
                value={config?.databaseURL ?? config?.database_url ?? ''}
                onChange={(e) => handleChange('databaseURL', e.target.value)}
                error={!!errors?.databaseURL}
                helperText={errors?.databaseURL || 'Để trống nếu dùng Firestore — Firestore chỉ cần Credentials (project ID có trong file JSON).'}
                placeholder="https://your-project.firebaseio.com (để trống nếu dùng Firestore)"
            />
            <Typography variant="body2" color="text.secondary">
                Credentials (service account JSON). Khi sửa, để trống nếu không đổi.
            </Typography>
            <TextField
                fullWidth
                label="Credentials JSON"
                multiline
                minRows={4}
                value={credentialsStr}
                onChange={(e) => handleChange('credentials_json', e.target.value)}
                placeholder='{"type": "service_account", ...}'
                helperText={isEdit && 'Chỉ điền khi cần thay đổi credentials'}
            />
        </Box>
    );
};

export default FirebaseSourceForm;
